import { AppState as RootAppState } from '../../../../providers/store/app.state';
import { HttpErrorResponse } from '@angular/common/http';


export interface LoginStateInterface {
    loggedIn: boolean;
    error?: HttpErrorResponse;
    jwt: string;
    tan?: string;
}

export class LoggedOutState implements LoginStateInterface {
    loggedIn = false;
    jwt = null;
    tan = null;
}

export class LoggedInState implements LoginStateInterface {
    loggedIn = true;

    constructor(public jwt: string, public tan: string = null) {
    }
}

export class LoginFailedState implements LoginStateInterface {
    loggedIn = false;
    jwt = null;
    tan = null;
    constructor(public error: HttpErrorResponse) {
    }
}

export interface AppState extends RootAppState {
    login: LoginStateInterface;
}
